export default __webpack_public_path__ + "static/media/lawenda.d9df791a.svg";